import React from 'react';

const ArrowIcon = ({ color = '#000', className, size = 50, ...props }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10 25h30M25 10l15 15-15 15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
);

export default ArrowIcon;